/**
 * Enumerable para posiciones del toast
 */

export enum EToastPosition {
  topRight = 'toast-top-right',
  topLeft = 'toast-top-left',
  bottomRight = 'toast-bottom-right',
  bottomLeft = 'toast-bottom-left',
  bottomCenter = 'toast-bottom-center',
}
